import { DataService } from '../core/data.service';
import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'game-debug-scorecard',
  templateUrl: './debug-scorecard.component.html',
  styleUrls: ['./debug-scorecard.component.scss']
})
export class DebugScorecardComponent implements OnInit {

  @HostBinding('class.isDead') public isDead: boolean;

  constructor(public dataService: DataService) { }

  ngOnInit() {
    this.dataService.hasDied.subscribe((value: boolean) => {this.isDead = value; });
  }
  findFood() {
    this.dataService.food++;
    this.dataService.currentEnergy--;
  }
  eatFood() {
    this.dataService.food--;
    this.dataService.currentSatiety += 1 + this.dataService.tools / 2 + this.dataService.shelter / 10;
  }

  gatherMaterials() {
    this.dataService.materials++;
    this.dataService.currentEnergy--;
  }

  buildTool() {
    this.dataService.materials -= Math.floor(Math.random() * 3) + this.dataService.tools;
    this.dataService.currentEnergy -= 5;
    this.dataService.tools++;
  }

  buildShelter() {
    this.dataService.tools -= 2;
    this.dataService.shelter++;
  }

  rest() {
    this.dataService.currentEnergy += 5 * (this.dataService.shelter / 2 + 1);
    this.dataService.currentSatiety -= 5;
  }

}



// WEBPACK FOOTER //
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/debug-scorecard/debug-scorecard.component.ts